import React from "react";
import { motion } from "framer-motion";
import image1 from "../../assets/about1.png";
import image2 from "../../assets/about2.png";
import image3 from "../../assets/about3.jpg";
import image4 from "../../assets/about4.png";
import image5 from "../../assets/about5.png";
import "./about.css";
import BackIcon from "../../components/back/back";
import { Typography } from "@mui/material";

export default function AboutUSDetailsDesktop() {
    const events = [
        {
            title: "1998: A Vision Takes Root",
            subtitle: "The Humble Beginnings of Jabal Amel Nurseries",
            description:
                "Hussein Tarhini, the visionary founder of Jabal Amel Nurseries, grew up in a farming family surrounded by prickly pears and olive trees. This early connection to nature inspired a lifelong commitment to revolutionizing agriculture in South Lebanon.",
            image: image1,
        },
        {
            title: "The First Steps",
            subtitle: "A Growing Vision from Humble Beginnings",
            description:
                "Hussein began his journey selling prickly pears on a wooden cart in bustling souks. His passion and dedication soon led him to expand his offerings to include a variety of local plants.",
            image: image2,
        },
        {
            title: "The Foundation is Laid",
            subtitle: "Jabal Amel’s First Branch in Ebba",
            description:
                "In 1998, the first Jabal Amel Nursery branch was established in Ebba, South Lebanon. Starting as a modest shop, it became a hub for local plants and flowers, marking the beginning of an inspiring journey.",
            image: image3,
        },
        {
            title: "A Flourishing Legacy",
            subtitle: "Pioneers in Landscaping and Plant Merchandise",
            description:
                "Today, Jabal Amel Nurseries stands as a leader in landscape design and plant merchandise, achieving remarkable success while staying true to its roots of fostering growth and innovation in agriculture.",
            image: image5,
        },
    ];

    return (
        <div className="about-us-section" >
            <BackIcon />
            <div className="carousel-container">
                <h2 className="about-us-title" style={{ fontSize: '2.5rem' }}>About Us</h2>

                {events.map((event, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="carousel-slide"
                        style={{ marginBottom: "3rem" }}
                    >
                        <div
                            style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem" }}
                            className={`slide-content ${index % 2 === 0 ? "row-normal" : "row-reverse"}`}
                        >
                            <motion.img
                                src={event.image}
                                alt={event.title}
                                className="slide-image"
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
                                }}
                                style={{ width: "30%", minWidth: "300px", objectFit: "cover" }}
                            />
                            <div className="slide-text" style={{ flex: 1 }}>
                                <Typography
                                    className="slide-title"
                                    sx={{ fontSize: { xs: '1rem', md: '2rem' } }}
                                    component="h1"
                                >
                                    {event.title}
                                </Typography>
                                <h2 className="slide-subtitle">{event.subtitle}</h2>
                                <p className="slide-description">{event.description}</p>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
